export default __webpack_public_path__ + "027943e6aee2efbb0551a36c89108d9a.png";